import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative overflow-hidden inline-flex items-center justify-center rounded-lg font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-orange-500 hover:bg-orange-400 hover:scale-105 text-white shadow-lg shadow-orange-500/20 focus:ring-orange-500 border border-transparent',
    secondary: 'bg-white hover:bg-gray-100 text-slate-900 focus:ring-white border border-transparent',
    outline: 'bg-transparent border-2 border-orange-500 text-orange-500 hover:bg-orange-500/10 focus:ring-orange-500',
    ghost: 'bg-transparent hover:bg-white/10 text-white focus:ring-white border border-transparent'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base',
    xl: 'h-16 px-10 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  // Shine effect animation
  const shineEffect = variant === 'primary' ? <div className="absolute inset-0 -translate-x-full animate-[shimmer_3s_infinite] bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-73" /> : null;
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className || ''}`;
  return <button className={combinedClassName} {...props} data-id="element-74">
      {children}
      {shineEffect}
    </button>;
}